import { alertStatusOptions, contractorAlertTypeOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { StatusOfAlert } from "components/table/columnComponents/StatusOfAlert"

export const alertsTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "",
    size: "mini",
    name: "checkbox",
    type: "checkbox",
    cellComponent: "checkbox",
  },
  {
    title: "Alerts",
    type: "select",
    name: "type",
    options: contractorAlertTypeOptions,
  },
  {
    title: "Date",
    type: "sort-date-range",
    name: "date",
  },
  {
    title: "Device S/N",
    type: "sort-search",
    name: "sn",
  },
  {
    title: "Status",
    type: "select",
    name: "status",
    options: alertStatusOptions,
    cellComponent: StatusOfAlert,
  },
  {
    title: "Full Name",
    type: "sort-search",
    name: "full_name",
  },
  {
    title: "Phone Number",
    type: "sort-search",
    name: "phone_number",
  },
  {
    title: "Email",
    type: "sort-search",
    name: "email",
  },
  {
    title: "Device Location",
    type: "sort-search",
    name: "location",
  },
  {
    title: "Country",
    type: "sort-search",
    name: "country",
  },
  {
    title: "Address",
    type: "sort-search",
    name: "address1",
  },
  {
    title: "City",
    type: "sort-search",
    name: "city",
  },
  {
    title: "State",
    type: "sort-search",
    name: "state",
  },
]
